var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConditionIconLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 525,
    height: 260,
    viewBox: "0 0 525 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M488.5 227C252.5 25 117.656 403.752 107.551 163C100.5 -5 -3.89416 143.949 -74.9487 41.5",
    stroke: "#F9E9E2",
    strokeWidth: 26
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M514.5 248C310.5 -17 119.551 342.5 128.551 165C137.551 -12.5 4.55127 116.212 -204 12",
    stroke: "white",
    strokeWidth: 26
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConditionIconLeft);
export default __webpack_public_path__ + "static/media/condition_icon_left.2da8b60e57bf687f641d6c383eeeb0a0.svg";
export { ForwardRef as ReactComponent };